import { BaseComponent } from '../../../components/BaseComponent';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { formatLicensePlate } from '../../../utils/string';

const STATE = {};

class RegplateLabelComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  get parsedRegplate() {
    return formatLicensePlate(this.props.regplate);
  }

  render() {
    if (!this.parsedRegplate) return '';

    return (
      <img
        src={`/api/v1/public/kenteken/?text=${this.parsedRegplate}`}
        width={this.props.width || '150'}
        height={this.props.height || ''}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const RegplateLabel = compose(withConnect, withRouter)(RegplateLabelComp);
